<template>
    <div>
        <b-card
                class="relais--card py-3"
                :class="{'br-4 block--shadow border-0 wr-header': isDesktop}"
        >
            <header class="relais--header pb-0">
                <h1 class="relais--title pb-1">
                    <i class="fas fa-child"></i>
                    Page Relais Alter Ego Digital
                </h1>
                <div class="row no-gutters relais--info">
                    <div class="col-1 px-0">
                        <i class="fas fa-info-circle"></i>
                    </div>
                    <div class="col-11 px-0">
                        <p class="mb-0">
                            Depuis cette page, gérez vos séances, vos conversations avec les coachs ainsi que vos
                            rappels
                            ...
                        </p>
                    </div>
                </div>
            </header>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'RelaisRoadlogInfo',
        data: () => ({
            isDesktop: window.innerWidth > 768
        })
    }
</script>